// Import PhotoSwipe dynamically
let PhotoSwipe = null;
let PhotoSwipeLightbox = null;

// Load PhotoSwipe library
(function loadPhotoSwipe() {
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.3/dist/umd/photoswipe-lightbox.umd.min.js';
  script.onload = function() {
    const script2 = document.createElement('script');
    script2.src = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.3/dist/umd/photoswipe.umd.min.js';
    script2.onload = function() {
      PhotoSwipeLightbox = window.PhotoSwipeLightbox;
      PhotoSwipe = window.PhotoSwipe;
      initPhotoSwipe();
    };
    document.head.appendChild(script2);
  };
  document.head.appendChild(script);
})();

// Initialize PhotoSwipe
function initPhotoSwipe() {
  if (!PhotoSwipeLightbox) return;

  const lightbox = new PhotoSwipeLightbox({
    gallery: '.gallery-swiper',
    children: 'a.pswp-gallery-item',
    pswpModule: PhotoSwipe,
    bgOpacity: 0.9,
    padding: { top: 50, bottom: 50, left: 50, right: 50 },
    wheelToZoom: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    showHideAnimationType: 'zoom',
  });

  // Prevent default link behavior
  lightbox.on('beforeOpen', () => {
    document.querySelectorAll('.pswp-gallery-item').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  });

  lightbox.init();
}

document.addEventListener("DOMContentLoaded", function () {
  // 初始化 gallery-thumbs swiper
  const thumbsSwiper = document.querySelector(".gallery-thumbs");

  if (thumbsSwiper) {
    thumbsSwiper.addEventListener("ready", (event) => {
      const swiper = event.detail[0];

      // 注入响应式断点配置
      swiper.params.breakpoints = {
        0: {
          spaceBetween: 6,
        },
        768: {
          spaceBetween: 10,
        },
      };

      // 更新 swiper 配置
      swiper.update();
    });
  }
});

if (!customElements.get("up-product-des")) {
  customElements.define(
    "up-product-des",
    class extends HTMLElement {
      constructor() {
        super();
      }
       connectedCallback() {
        this.revealGalleryWhenReady();
        this.setupEventListeners();
        this.setupGalleryNavigation();
      }

     revealGalleryWhenReady() {
        const removeAbsolute = () => {
          this.querySelectorAll(".absolute-slide").forEach((slide) => {
            slide.classList.remove("absolute-slide");
          });
        };

        customElements.whenDefined("swiper-container").then(() => {
          const gallerySwiper = this.querySelector("[data-gallery-swiper]");

          // If Swiper isn't present for some reason, just reveal everything.
          if (!gallerySwiper) {
            removeAbsolute();
            return;
          }

          // Swiper may already be initialised by the time the element is
          // defined, otherwise wait for its init event. A short fallback
          // guarantees the gallery is never left hidden.
          if (gallerySwiper.swiper && gallerySwiper.swiper.initialized) {
            removeAbsolute();
          } else {
            gallerySwiper.addEventListener("swiperinit", removeAbsolute, {
              once: true,
            });
            setTimeout(removeAbsolute, 300);
          }
        });
      }

      setupGalleryNavigation() {
        const gallerySwiper = this.querySelector("[data-gallery-swiper]");
        const prevButton = this.querySelector("[data-gallery-prev]");
        const nextButton = this.querySelector("[data-gallery-next]");

        if (gallerySwiper && prevButton && nextButton) {
          // Use the swiper property directly or wait for initialization
          const initNavigation = () => {
            // Try to get swiper instance
            const swiper = gallerySwiper.swiper;

            if (!swiper) {
              // If swiper not ready, wait and try again
              setTimeout(initNavigation, 100);
              return;
            }

            // Add click handlers for navigation buttons
            prevButton.addEventListener("click", () => {
              if (gallerySwiper.swiper) {
                gallerySwiper.swiper.slidePrev();
              }
            });

            nextButton.addEventListener("click", () => {
              if (gallerySwiper.swiper) {
                gallerySwiper.swiper.slideNext();
              }
            });

            // Update button states based on current slide
            const updateButtons = () => {
              const swiperInstance = gallerySwiper.swiper;
              if (!swiperInstance) return;

              if (swiperInstance.isBeginning) {
                prevButton.style.opacity = "0.5";
                prevButton.style.pointerEvents = "none";
              } else {
                prevButton.style.opacity = "1";
                prevButton.style.pointerEvents = "auto";
              }

              if (swiperInstance.isEnd) {
                nextButton.style.opacity = "0.5";
                nextButton.style.pointerEvents = "none";
              } else {
                nextButton.style.opacity = "1";
                nextButton.style.pointerEvents = "auto";
              }
            };

            // Listen for slide change events
            gallerySwiper.addEventListener("swiperslidechange", updateButtons);

            // Initial update
            updateButtons();
          };

          // Start initialization
          setTimeout(initNavigation, 500);
        }
      }

      setupEventListeners() {
        // Add to bag button
        const addToCartInner = this.querySelector("#addToCart");
        const addToBagBtn = this.querySelector("[data-button]");
        const addToCartWrapper = this.querySelector("#addToCartWrapper");

        addToCartInner.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          console.log('addToCartInner click', addToCartWrapper.classList.contains('free-gift-loading'));

          if (addToCartWrapper.classList.contains("free-gift-loading")) {
            return;
          }

          addToCartWrapper.classList.add("free-gift-loading");

          addToBagBtn.click();
        });

        if (addToBagBtn) {
          addToBagBtn.addEventListener("click", (event) => {
            console.log("addToBagBtn click");
            event.preventDefault();

            const subscriptionSelector = document.querySelector(
              "subscription-selector",
            );
            const selectedOption = document.querySelector(
              ".recharge-subscription .suggested-option.selected",
            );
            const productJson = document.getElementById("product-json");
            const product = productJson
              ? JSON.parse(productJson.textContent)
              : null;

            // Get the variant ID based on selected option or default
            let variantId =
              product?.selected_or_first_available_variant?.id ||
              product?.variants?.[0]?.id;

            // Check if variant selector is visible and has a value (for one-time purchase)
            const variantSelect = document.querySelector(
              ".product-form__variants",
            );
            if (
              variantSelect &&
              !variantSelect.closest(".hidden") &&
              variantSelect.value
            ) {
              variantId = variantSelect.value;
            }

            // If a suggested option is selected, use its variant ID (override variant select)
            if (selectedOption) {
              variantId = selectedOption.getAttribute("data-variant-id");
            }

            // Also check the subscription-selector's data-variant-id attribute
            if (
              subscriptionSelector &&
              subscriptionSelector.getAttribute("data-variant-id")
            ) {
              const selectorVariantId =
                subscriptionSelector.getAttribute("data-variant-id");
              if (selectorVariantId && selectorVariantId !== variantId) {
                variantId = selectorVariantId;
              }
            }

            const quantity =
              this.querySelector("[data-quantity-input]")?.value || 1;

            // Check if subscription is selected (default is subscription now)
            const isSubscription = subscriptionSelector
              ? subscriptionSelector.selectedPurchaseType !== "one-time"
              : true; // Default to subscription when no selector exists
            const planId = subscriptionSelector?.getAttribute("data-plan-id");

            // For subscriptions, get the external variant ID from Recharge data
            if (
              isSubscription &&
              subscriptionSelector &&
              typeof subscriptionSelector.getExternalVariantId === "function"
            ) {
              const externalVariantId =
                subscriptionSelector.getExternalVariantId(variantId);
              if (externalVariantId) {
                variantId = externalVariantId;
              }
            }

            if (variantId) {
              // Note: addToCartWrapper already has "free-gift-loading" class from addToCartInner click handler
              // No need to add it again here

              // Prepare data based on purchase type
              let itemData = {};

              if (isSubscription && planId) {
                // Add subscription parameters
                itemData = {
                  id: variantId,
                  quantity: quantity,
                  selling_plan: planId,
                  [`selling_plan_${planId}`]: "subsave",
                };

                // Use fetch for subscription as CartJS might not support selling_plan
                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(itemData),
                })
                  .then((response) => response.json())
                  .then((data) => {
                    fetchCart();
                    addToCartWrapper.classList.remove("free-gift-loading");
                  })
                  .catch((error) => {
                    addToCartWrapper.classList.remove("free-gift-loading");
                    console.error("Error adding subscription to cart:", error);
                  });
              } else {
                // Regular one-time purchase
                CartJS.addItem(
                  variantId,
                  quantity,
                  {},
                  {
                    success: (data) => {
                      fetchCart();
                      addToCartWrapper.classList.remove("free-gift-loading");
                    },
                    error: (error) => {
                      addToCartWrapper.classList.remove("free-gift-loading");
                      console.error("Error adding item to cart:", error);
                    },
                  },
                );
              }
            } else {
              // If no variant ID, remove loading state
              addToCartWrapper.classList.remove("free-gift-loading");
              console.error("No variant ID found");
            }
          });
        }

        // Add bundle button
        const addBundleBtn = this.querySelector('[data-action="add-bundle"]');
        if (addBundleBtn) {
          addBundleBtn.addEventListener("click", (event) => {
            event.preventDefault();
            const variantId = addBundleBtn.dataset.varId;

            if (variantId) {
              addBundleBtn.classList.add("free-gift-loading");
              CartJS.addItem(
                variantId,
                1,
                {},
                {
                  success: (data) => {
                    // Handle success if needed
                    fetchCart();
                    addBundleBtn.classList.remove("free-gift-loading");
                  },
                  error: (error) => {
                    addBundleBtn.classList.remove("free-gift-loading");
                    console.error("Error adding bundle to cart:", error);
                  },
                },
              );
            }
          });
        }
      }
    },
  );
}
